import { Bug, Lightbulb, Star, MessageSquare } from 'lucide-react'

import type { IFeedbackType } from './FeedbackModal.types'

// Feedback types matching the backend API requirements
export const FEEDBACK_TYPES: IFeedbackType[] = [
    { value: 'bug', label: 'Bug Report', icon: Bug, color: 'error' },
    { value: 'feature', label: 'Feature Request', icon: Lightbulb, color: 'warning' },
    { value: 'improvement', label: 'Improvement', icon: Star, color: 'primary' },
    { value: 'general', label: 'General Feedback', icon: MessageSquare, color: 'neutral' },
]
